module.exports = __webpack_public_path__ + "assets/klaviyo.ce6c3c9c.svg";